// extracted by mini-css-extract-plugin
export default {"Container":"_R4Ze6GvXknW57OXpLlQ","Tags":"IQsRmqNR9CexSvOTh0kf","Tag":"xcuOfScDzPRgyth3_sdU","Label":"v0mZkQ1ML2E_9fUMe2ew","RemoveIcon":"zUS4fTkp_zBBSc4PTIQt"};